import { Grid } from "@mui/material";
import Spinner from "./Spinner";

const LoadingPage = () => {
  return (
    <Grid
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        zIndex: 999999,
      }}
    >
      <Spinner />
    </Grid>
  );
};

export default LoadingPage;
